const IFRAME_SRC = `${process.env.PUBLIC_URL}/icc/index.html`

const InterventionPortal = () => {
  return (
    <iframe
      src={IFRAME_SRC}
      title="GroNEXT Intervention Command Centre"
      width="100%"
      height="100%"
      style={{ border: 'none', minHeight: '100vh' }}
    />
  )
}

export default InterventionPortal
